import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import MainHeroBanner from "../assets/images/cms/sky-shape.png";
import BannerLogo from "../assets/images/home/banner-logo.png";
import useAppDispatch from "../hooks/useAppDispatch";
import { openModal, type ModalType } from "../redux/slices/uiSlice";
import { useTranslation } from "react-i18next";
import SecondaryBtn from "../components/button/SecondaryBtn";
import YellowBg from "../assets/images/comman/yellow-bg.png";
import Masonary from "../components/category/Masonary";

const Home = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const isScrollingFromClick = useRef(false);
  const { t } = useTranslation();
  // Section IDs to observe (home is for the hero section at top)
  const sectionIds = ["home", "categories", "aboutus"];

  // Scroll to hash on initial load or hash change
  useEffect(() => {
    if (hash) {
      isScrollingFromClick.current = true;
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        // Reset the flag after scroll animation completes
        setTimeout(() => {
          isScrollingFromClick.current = false;
        }, 1000);
      }
    }
  }, [hash]);

  // Intersection Observer to update hash on manual scroll
  // useEffect(() => {
  //   const observerOptions: IntersectionObserverInit = {
  //     root: null,
  //     rootMargin: "-50% 0px -50% 0px", // Trigger when section is in middle of viewport
  //     threshold: 0,
  //   };

  //   const observerCallback: IntersectionObserverCallback = (entries) => {
  //     // Don't update hash if we're scrolling from a link click
  //     if (isScrollingFromClick.current) return;

  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         const sectionId = entry.target.id;

  //         // Clear hash when at home/top section
  //         if (sectionId === "home") {
  //           if (window.location.hash) {
  //             navigate("", { replace: true });
  //           }
  //         } else {
  //           const newHash = `#${sectionId}`;
  //           // Only update if hash is different
  //           if (window.location.hash !== newHash) {
  //             navigate(newHash, { replace: true });
  //           }
  //         }
  //       }
  //     });
  //   };

  //   const observer = new IntersectionObserver(observerCallback, observerOptions);

  //   // Observe all sections with IDs
  //   sectionIds.forEach((id) => {
  //     const section = document.getElementById(id);
  //     if (section) {
  //       observer.observe(section);
  //     }
  //   });

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [navigate]);

  const dispatch = useAppDispatch();
  const handleOpenModal = (modalType: ModalType) => {
    dispatch(openModal(modalType));
  };

  return (
    <>
      <div className="wrapper flex-1">
        <section
          id="home"
          className="w-full bg-cover bg-top bg-no-repeat flex justify-center items-center relative 2xl:h-[36vw] xl:h-[500px] h-[400px]"
        >
          <div
            className="w-full bg-cover bg-center bg-no-repeat flex justify-center items-center h-full bg-primary-skyblue"
          // style={{ backgroundImage: `url(${MainHeroBanner})` }}
          >
            <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4 flex flex-col items-center justify-between">
              <img
                src={BannerLogo}
                alt="logo"
                className="2xl:h-[18.229vw] md:h-[230px]  h-[150px] w-full object-contain 2xl:mb-[1.2vw] mb-5"
              />
              {/* <h1 className="xl:text-[4.792vw]/[4.8vw] text-5xl/12 font-medium text-center text-primary lg:mb-[0.5vw] md:mb-5 mb-4 text-stroke-white uppercase lg:px-[1vw] px-5">
                {t("home.welcomeTo")}
                <span className="block text-primary-bright font-semibold xl:text-[5.833vw]/[5.5vw] text-6xl/14">
                  {t("home.khoshMajlis")}
                </span>
              </h1>
              <p className="font-normal 2xl:text-[1.042vw]/tight text-lg/tight text-white text-center w-full 2xl:max-w-[32.135vw] max-w-[617px] lg:mb-[1.2vw] md:mb-5 mb-4 mt-4">
                {t("home.description")}
              </p> */}

              <div className="flex flex-row 2xl:gap-[1.3vw] md:gap-3 gap-2 justify-center items-center w-full 2xl:mb-[2vw] mt-15">
                <button
                  onClick={() => handleOpenModal("login")}
                  className={`flex items-center justify-center max-w-fit! whitespace-nowrap w-full 2xl:min-h-[2.5vw] md:min-h-[40px] min-h-8  lg:mb-[1.1vw] md:mb-5 mb-4 2xl:rounded-[0.26vw] rounded-[5px] h-full skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.042vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-black-300 bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
                  `}
                >
                  <span className="2xl:pt-[0.5vw] md:pt-2 pt-2 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.3vw] md:py-1.5 py-1.5 2xl:px-[1.2vw] md:px-8 px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[#F3E8D4] w-full">
                    <span className="skew-x-[10deg] block">{t("home.login")}</span>
                  </span>
                </button>
                <button
                  onClick={() => handleOpenModal("login")}
                  className={`flex items-center justify-center max-w-fit! whitespace-nowrap w-full 2xl:min-h-[3vw] md:min-h-[55px] min-h-[50px]  lg:mb-[1.1vw] md:mb-5 mb-4 2xl:rounded-[0.26vw] rounded-[5px] h-full skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.3vw]/[1.4vw] md:text-xl/tight text-base/tight font-bold text-black-300 bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
                  `}
                >
                  <span className="2xl:pt-[0.9vw] md:pt-3.5 pt-3 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.7vw] md:py-2.5 py-3 2xl:px-[1.2vw] md:px-8 px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-white w-full">
                    <span className="skew-x-[10deg] block text-xl">{t("home.createGame")}</span>
                  </span>
                </button>
                <button
                  onClick={() => handleOpenModal("register")}
                  className={`flex items-center justify-center max-w-fit! whitespace-nowrap w-full 2xl:min-h-[2.5vw] md:min-h-[40px] min-h-8  lg:mb-[1.1vw] md:mb-5 mb-4 2xl:rounded-[0.26vw] rounded-[5px] h-full skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.042vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-black-300 bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]
                  `}
                >
                  <span className="2xl:pt-[0.5vw] md:pt-2 pt-2 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.3vw] md:py-1.5 py-1.5 2xl:px-[1.2vw] md:px-8 px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[#F3E8D4] w-full">
                    <span className="skew-x-[10deg] block">{t("home.signup")}</span>
                  </span>
                </button>
                {/* <PrimaryBtn onClick={() => handleOpenModal("register")} className="md:flex-none flex-1 max-w-fit! w-full">
                   <span className="bg-[#F3E8D4]! px-4">
                    <span>{t("home.signup")}</span></span>
                </PrimaryBtn> */}
              </div>
            </div>
          </div>
        </section>

        <section className="2xl:pb-[4vw] lg:pb-15 pb-10 2xl:pt-[1vw]! pt-6  overflow-x-hidden bg-primary-ivory" id="categories">
          <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4">
            <div className="flex 2xl:gap-[3vw] gap-10 items-center md:flex-nowrap flex-wrap">
              <div className="w-full">
                <Masonary />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
